import { render } from "./Galerie.vue?vue&type=template&id=5d3040ca"
import script from "./Galerie.vue?vue&type=script&lang=js"
export * from "./Galerie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__